import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { COLORS, FONT } from "../../constants";
import { STEPS, isDev } from "./constants";

const StepNavigation = ({
  currentStep,
  isCurrentStepValid,
  isMobile,
  onBack,
  onNext,
}) => {
  return (
    <>
      {/* Step counter / back button row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1.5,
          mb: 3,
        }}
      >
        {currentStep > 1 && currentStep <= STEPS.length && (
          <Button
            onClick={onBack}
            sx={{
              minWidth: 36,
              width: 36,
              height: 36,
              borderRadius: "99px",
              border: `1px solid #d0d0d0`,
              color: COLORS.darkText,
              fontSize: FONT.size.sm,
              p: 0,
              boxShadow: "none",
              "&:hover": {
                borderColor: COLORS.themeBlack,
                backgroundColor: "transparent",
              },
            }}
          >
            ←
          </Button>
        )}
        {currentStep <= STEPS.length && (
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: isMobile ? FONT.size.lg : FONT.size.xl,
              color: COLORS.themeBlack,
            }}
          >
            {currentStep}/{STEPS.length}
          </Typography>
        )}
      </Box>
    </>
  );
};

export const NextButton = ({ currentStep, isCurrentStepValid, isMobile, onNext }) => (
  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
    <Button
      variant="contained"
      onClick={onNext}
      disabled={!isDev && !isCurrentStepValid}
      sx={{
        backgroundColor: COLORS.themeRed,
        color: COLORS.white,
        fontWeight: 600,
        px: 6,
        py: 1.5,
        borderRadius: "2px",
        textTransform: "none",
        fontSize: isMobile ? FONT.size.sm : FONT.size.md,
        boxShadow: "none",
        "&:hover": { backgroundColor: COLORS.themeRed, boxShadow: "none" },
        "&.Mui-disabled": { backgroundColor: COLORS.lightGray, color: COLORS.white },
      }}
    >
      {currentStep === STEPS.length ? "Complete Application" : "Next"}
    </Button>
  </Box>
);

export default StepNavigation;
